import * as classNames from 'classnames'
import * as React from 'react'

export interface IEntityTabBarItemProps {
  children?: any
  active: boolean
  onClick?: () => void
}

const EntityTabBarItem = (props: IEntityTabBarItemProps) => {
  const style = classNames(
    'tab-bar--item flex mr3 py1 cursor--pointer font-dark-grey h6 uppercase',
    { 'bb-width-2 bb-green bold': props.active },
    { 'bb-width-2 bb-transparent': !props.active }
  )

  return (
    <div className={style} onClick={props.onClick}>
      {props.children}
    </div>
  )
}

export default EntityTabBarItem



// WEBPACK FOOTER //
// ./src/components/ui/entity/EntityTabBarItem.tsx